import axios from 'axios';

const state = {
  items: [],
  item: null
};

const getters = {
  getItem: state => state.item,
  getItems: state => state.items,
};

const mutations = {
  itemsLoaded(state, payload) {
    state.items = payload;
  },
  itemLoaded(state, payload) {
    state.item = payload;
  },
};

const actions = {
  getReport(state, id) {
    return axios.get(`/pbi-reports/view/${id}`);
  },
  getReports() {
    return axios.get(`/pbi-reports/viewer/reports`);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};